import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import './plugins/element';
import './assets/styles/animate.css';
import './assets/styles/public.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    // 触发预渲染事件
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app');
